import { createAction, props } from '@ngrx/store';
import { TermsAndConditions } from '../models/terms-and-conditions.model';

export const loadGetTermsAndConditions = createAction(
  '[TermsAndConditions] Load Get Terms And Conditions',
  props<{ request: { dialingCode: string } }>()
);

export const loadGetTermsAndConditionsSuccess = createAction(
  '[TermsAndConditions] Load Get Terms And Conditions Success',
  props<{ response: TermsAndConditions }>()
);

export const loadGetTermsAndConditionsFailure = createAction(
  '[TermsAndConditions] Load Get Terms And Conditions Failure',
  props<{ error: Error | any }>()
);
